import { WithStyles, withStyles } from '@mui/styles';

import ActionStatusModal from './actionStatusModal';
import { muiStyles } from './styles';

export interface ActionStatusModalProps extends WithStyles<typeof muiStyles> {
    open: boolean;
    onClose: () => void;
    validationFailure: boolean;
    BodyComponent: React.ReactNode;
}

export interface DeterminateHeaderIconProps extends WithStyles<typeof muiStyles> {
    validationFailure: boolean;
}

export default withStyles(muiStyles)(ActionStatusModal);